<template lang="pug">
  v-img(
    :src="image || require('@/assets/bg-course.svg?inline')"
    width="100%"
    :aspect-ratio="3"
    position="center"
    :gradient="calculateGradient"
  ).title-section
    v-container(fill-height)
      v-sheet(max-width=800 color="transparent" :dark="settings.light")
        C-input(
          v-if="!readonly"
          :value="value.title"
          :readonly="readonly"
          :class="{ 'white--text': settings.light }"
          @input="updateByKey('title', $event)"
        ).text-h4.font-weight-bold
        .text-h4.font-weight-bold(v-else) {{ value.title }}
        C-input(
          v-if="!readonly"
          :value="value.description"
          :readonly="readonly"
          :class="{ 'white--text': settings.light }"
          @input="updateByKey('description', $event)"
        ).my-1
        .my-1(v-else) {{ value.description }}
        slot(name="title-slot")
    .title-section--settings(v-if="!readonly")
      v-menu(
        v-model="settings.menuShow"
        :close-on-content-click="false"
        bottom
        offset-y
        min-width="500"
        max-width="600"
        @input="$event ? null : $set(settings.background, 'preview', null)"
      )
        template(#activator="{ on }")
          v-btn(
            v-on="on"
            depressed
            dark
          ).px-6.settings-btn
            v-icon(left) mdi-cog
            span Настройки картинки
        v-card
          v-card-text
            image-cropper(
              ref="cropper"
              v-model="settings.background.value"
              :url.sync="settings.background.url"
              :aspect-ratio="3"
              view-close
              @update:url="settings.background.url = $event"
              @input="onChangeBackground"
              @preview="$set(settings.background, 'preview', $event)"
            )
            v-subheader Степень затемненности
            v-slider(
              :value="value.shadow_level"
              color="secondary"
              thumb-label
              ticks
              @input="updateByKey('shadow_level', $event)"
            )
          v-card-actions
            v-spacer
            v-btn(
              depressed
              @click="settings.menuShow = false"
            )
              span Закрыть
            v-btn(
              color="success"
              depressed
              @click="$refs.cropper.uploadCropped(); settings.menuShow = false"
            )
              span Сохранить
</template>

<script>
import { mapGetters } from 'vuex';

import CInput from '@/components/Constructor/CInput.vue';
import ImageCropper from '@/components/InputFields/imageCropper.vue';

const DEFAULT_SHADOW_LEVEL = 70;

export default {
  components: {
    CInput,
    ImageCropper,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        title: null,
        description: null,
        shadow_level: DEFAULT_SHADOW_LEVEL,
        background: null,
      }),
    },
    readonly: { type: Boolean, default: false },
  },
  data: () => ({
    settings: {
      background: {
        value: null,
        url: null,
        preview: null,
      },
      menuShow: false,
      light: true,
    },
  }),
  computed: {
    ...mapGetters({
      userData: 'auth/userData',
    }),
    image() {
      return this.settings.background.preview || this.settings.background.url;
    },
    calculateGradient() {
      const rightSideShadow = this.value.shadow_level / 100;
      const leftSideShadow = (this.value.shadow_level - 33) / 100;
      return `90deg, rgba(70, 69, 85, ${rightSideShadow}) 40%, rgba(70, 69, 85, ${leftSideShadow})`;
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.settings.background = this.value.background ? {
        value: this.value.background.filename,
        url: this.value.background.url,
      } : {
        value: null,
        url: null,
      };
    },
    updateByKey(key, value) {
      this.$emit('input', {
        ...this.value,
        [key]: value,
      });
    },
    onChangeBackground(val) {
      if (val) {
        this.updateByKey('background', {
          filename: this.settings.background.value,
          url: this.settings.background.url,
        });
      } else {
        this.updateByKey('background', null);
      }
    },

  },
};
</script>

<style lang="scss" scoped>
.title-section {
  position: relative;
  overflow: hidden;

  &--settings {
    position: absolute;
    bottom: 0;
    width: 100%;
    text-align: center;

    .settings-btn {
      background: rgba($color: $secondary-color, $alpha: .7);
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
}
</style>
